import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { motion, AnimatePresence } from 'framer-motion'

const STORAGE_KEY = 'niceday-cookie-consent'

export default function CookieConsent() {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === null) setVisible(true)
  }, [])

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted')
    setVisible(false)
  }

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined')
    setVisible(false)
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'tween', duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-5 bg-slate-800 text-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
        >
          <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
            <p className="text-sm flex-1">
              {t('cookieConsent.message')}{' '}
              <Link
                to="/cookies"
                className="text-primary font-medium underline hover:no-underline"
              >
                {t('cookieConsent.link')}
              </Link>
            </p>
            <div className="flex gap-3 w-full sm:w-auto shrink-0">
              <button
                onClick={accept}
                className="px-5 py-2.5 bg-primary text-white rounded-xl font-semibold text-sm hover:bg-primary/90 transition-colors"
              >
                {t('cookieConsent.accept')}
              </button>
              <button
                onClick={decline}
                className="px-5 py-2.5 bg-slate-600 text-white rounded-xl font-semibold text-sm hover:bg-slate-500 transition-colors"
              >
                {t('cookieConsent.decline')}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
